export function resolveMediaUrl(value) {
    if (!value || typeof value !== 'string') return '';
    const trimmed = value.trim();
    if (!trimmed) return '';
    if (/^https?:\/\//i.test(trimmed)) return trimmed;
    if (/^(data:|blob:)/i.test(trimmed)) return trimmed;
    // Bundled frontend assets (e.g. CRA /static/media/...) — do not prefix with API base
    if (trimmed.startsWith('/static/') || trimmed.includes('/static/media/')) return trimmed;
    const base = (process.env.REACT_APP_API_BASE_URL || '').replace(/\/$/, '');
    if (!base) return trimmed;
    return trimmed.startsWith('/') ? `${base}${trimmed}` : `${base}/${trimmed}`;
}
